const LOCAL_HR_BASE =
  window.__APP_CONFIG__?.LOCAL_HR_BASE ||
  process.env.VUE_APP_LOCAL_HR_BASE ||
  "http://localhost:8090";

async function localFetch(path, opts = {}) {
  const res = await fetch(`${LOCAL_HR_BASE}${path}`, {
    headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
    ...opts,
  });

  if (!res.ok) {
    let message = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      if (data?.error) message = data.error;
    } catch {
      // ignore
    }
    throw new Error(message);
  }

  return res.json();
}

export function getLocalHrBase() {
  return LOCAL_HR_BASE;
}

export function getLocalHrHealth() {
  return localFetch("/health");
}

export function getLocalDevices() {
  return localFetch("/devices");
}

export function getCurrentSession() {
  return localFetch("/session/current");
}

export function startLocalSession(payload) {
  return localFetch("/session/start", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function addParticipant(payload) {
  return localFetch("/session/add-participant", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function removeParticipant(participantId) {
  return localFetch("/session/remove-participant", {
    method: "POST",
    body: JSON.stringify({ participant_id: participantId }),
  });
}

export function reassignDevice(participantId, newDeviceNo) {
  return localFetch("/session/reassign-device", {
    method: "POST",
    body: JSON.stringify({
      participant_id: participantId,
      new_device_no: newDeviceNo,
    }),
  });
}

export function syncSession(participants, classId) {
  return localFetch("/session/sync", {
    method: "POST",
    body: JSON.stringify({ participants, class_id: classId || null }),
  });
}

// TV 보드 순위·시간표 캐시 즉시 재조회
export function refreshBoard() {
  return localFetch("/board/refresh", {
    method: "POST",
  });
}

export function getSessionsByClass(classId) {
  return localFetch(`/sessions/by-class/${classId}`);
}

export function stopLocalSession(saveLocalBackup = true) {
  return localFetch("/session/stop", {
    method: "POST",
    body: JSON.stringify({ save_local_backup: saveLocalBackup }),
  });
}

// 기기 관리
export function addDevice(payload) {
  return localFetch("/devices", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateDevice(deviceNo, payload) {
  return localFetch(`/devices/${deviceNo}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function deleteDevice(deviceNo) {
  return localFetch(`/devices/${deviceNo}`, {
    method: "DELETE",
  });
}

export function scanDevices() {
  return localFetch("/devices/scan", {
    method: "POST",
  });
}
